<template>
  <div class="custom-logo" @click="handleClick">
    <img
      loading="lazy"
      :src="model.logo.url"
      class="block mx-auto h-full object-contain"
    />
    <div class="custom-logo__hover">
      <iconpark-icon name="camera" class="text-[20px] text-white" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { reqUpdateLogo } from '~/api'
import { useAvatarUpload } from '~/hooks/useModal/modals/avatar/index'

// const userInfo = useUserInfo()
const model = useCustomSetting()

// const enableEdit = computed(() => userInfo.value?.is_edit_logo)

function updateLog(path: string) {
  const userInfo = useUserInfo()
  return reqUpdateLogo({
    platform_logo_path: path.replace(/.*(?=youyan\/.*)/, ''),
    organization_id: userInfo.value?.organization_id || 0,
  })
}

function handleClick() {
  // if (!enableEdit.value) {
  //   return
  // }
  const { $t } = useNuxtApp()

  useAvatarUpload({
    title: $t('shang-chuan-logo'),
    tip: $t(
      'jin-zhi-chi-jpgjpegpng-ge-shi-da-xiao-xiao-yu-3m-tui-jian-tu-pian-bi-li-wei-94-tui-jian-tu-pian-bi-li-wei-94'
    ),
    url: model.value.logo.url,
    defaultUrl: model.value.logo.default_url,
    request: updateLog,
    success(data: any) {
      CustomSettingApp.setLogo(
        typeof data === 'string' ? data : data.platform_logo_url
      )
    },
  })
}
</script>

<style lang="scss">
.custom-logo {
  position: relative;
  width: 68px;
  height: 28px;
  border: 1px solid var(--back-3);
  border-radius: 6px;
  cursor: pointer;
  &__hover {
    @apply absolute-full flex-center bg-font-30 bg-opacity-30 opacity-0;
    transition: opacity 0.3s ease;
    border-radius: 6px;
    &:hover {
      opacity: 1;
    }
  }
}
</style>
